export default "__VITE_ASSET__DvmewXP3__"